import { baseApi } from 'core/api';

const state = () => ({
    _businessHours: [],
});

const getters = {
    businessHours: (state) => state._businessHours,
};

const actions = {
    updateBusinessHours(form) {
        return form.post('core/business-hours').then((response) => {
            const data = response.data;

            this.businessHoursUpdated(data);

            return data;
        });
    },

    businessHoursUpdated(data) {
        if (data.numberable_type !== 'App\\\Teams\\\Team') {
            this._setBusinessHoursLoaded(data);
        }
    },

    getBusinessHours() {
        return baseApi.get('core/users/business-hours').then((response) => {
            this._setBusinessHoursLoaded(response.data);

            return response.data;
        });
    },

    _setBusinessHoursLoaded(data) {
        this._businessHours = data;
    },
};

export default {
    state,
    getters,
    actions,
};
